module.exports = __webpack_public_path__ + "img/20200515_164248.c9eebe62.jpg";